import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";

interface DocumentModalFieldType {
  name: string;
  type: InputfieldTypes;
  label: string;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  visible?: boolean;
}

export const addDocumentModalFields: DocumentModalFieldType[] = (
  isQuarryDoc?: boolean,
  materialOptions?: []
) => [
  {
    name: "docName",
    type: InputfieldTypes.TEXT,
    label: "Document Name",
    placeholder: "Enter document name",
    required: true,
    disabled: false,
    visible: true,
    span: 12,
  },
  {
    name: "date",
    type: InputfieldTypes.TEXT,
    label: "Date",
    placeholder: "Current date",
    required: true,
    disabled: true,
    visible: true,
    span: 12,
  },
  {
    name: "materialId",
    type: InputfieldTypes.SELECT,
    label: "Material",
    placeholder: "Select",
    required: false,
    disabled: false,
    options: materialOptions,
    visible: isQuarryDoc,
    span: 12,
  },
  {
    name: "docType",
    type: InputfieldTypes.SELECT,
    label: "Type",
    placeholder: "Select",
    required: true,
    disabled: false,
    visible: !isQuarryDoc,
    span: 12,
  },
  {
    name: "description",
    type: InputfieldTypes.TEXT_AREA,
    label: "Document Description",
    placeholder: "Enter document description",
    maxLength: 500,
    noResize: true,
    required: false,
    disabled: false,
    visible: isQuarryDoc,
    span: 24,
  },
];
